import '../CSS/Projects.css';

import React from 'react';
import { Carousel } from 'react-responsive-carousel';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import useScrollFadeIn from '../components/useScrollFadeIn';
import { useTranslation } from 'react-i18next';

import cryptex1 from '../assets/icons/slide1.webp';
import cryptex2 from '../assets/icons/slide2.webp';
import cryptex3 from '../assets/icons/slide3.webp';
import cryptex4 from '../assets/icons/slide4.webp';

import githubIcon from '../assets/icons/github.svg';
import penIcon from '../assets/icons/pen.svg';

function Projects() {
  const { t } = useTranslation();
  // Scroll-fade-in hookit
  const [headerRef, headerVisible] = useScrollFadeIn();
  const [beltRef, beltVisible] = useScrollFadeIn();
  const [collectRef, collectVisible] = useScrollFadeIn();
  const [cryptexRef, cryptexVisible] = useScrollFadeIn();
  const [photographyCVRef, photographyCVVisible] = useScrollFadeIn();
  const [merakiClothingRef, merakiClothingVisible] = useScrollFadeIn();

  return (
    <div className="Projects-wrapper container mt-5">
      <div className="row justify-content-center">
        <div className="col-11 px-2 px-md-1">

          {/* Header-osio */}
          <div
            ref={headerRef}
            className={`header-section fade-in-section ${headerVisible ? 'visible' : ''} mb-5`}
          >
            <h1 className='header-name mb-4 mb-md-5'>Portfolio</h1>
            <p className='subtext'>
              {t('Projects.headerSubtext1')}
            </p>
            <p className='subtext'>
              {t('Projects.headerSubtext2')}
            </p>
            <div className="Degree d-flex align-items-center pt-4 pt-sm-5">
              <img src={penIcon} alt="Degree" />
              <a href="https://oamk.fi/koulutus/ammattikorkeakoulututkinnot/tradenomi-amk-tietojenkasittely/" target="_blank" rel="noopener noreferrer">{t('Projects.degree')}</a>
            </div>
            <div className="Github d-flex align-items-center pt-4 pt-sm-5">
              <img src={githubIcon} alt="Github" />
              <a href="https://github.com/AkseliRaj" target="_blank" rel="noopener noreferrer">{t('Projects.github')}</a>
            </div>
          </div>

          {/* Meraki Clothing */}
          <div
            ref={merakiClothingRef}
            className={`project-section fade-in-section ${merakiClothingVisible ? 'visible' : ''} mb-5`}
          >
            <h2 className="header-name mb-4 mb-md-5">Meraki Clothing</h2>
            <div className="video-wrapper mb-5">
              <iframe
                src="https://www.youtube.com/embed/YVzdgLcGanU"
                title="Meraki Clothing video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <p className="subtext">
              {t('Projects.merakiClothingSubtext')}
            </p>
          </div>

          {/* Photography CV */}
          <div
            ref={photographyCVRef}
            className={`project-section fade-in-section ${photographyCVVisible ? 'visible' : ''} mb-5`}
          >
            <h2 className="header-name mb-4 mb-md-5">Photography CV</h2>
            <div className="video-wrapper mb-5">
              <iframe
                src="https://www.youtube.com/embed/mjSeMSQ0EXM"
                title="Photography CV video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <p className="subtext">
              {t('Projects.photographyCVSubtext')}
            </p>
            <div className="Github d-flex align-items-center pt-4 pt-sm-5">
              <img src={githubIcon} alt="Github" />
              <a href="https://github.com/AkseliRaj/valokuvaus-cv" target="_blank" rel="noopener noreferrer">{t('Projects.photographyCVGithub')}</a>
            </div>
          </div>

          {/* Beltstorm-osio */}
          <div
            ref={beltRef}
            className={`project-section fade-in-section ${beltVisible ? 'visible' : ''} mb-5`}
          >
            <h2 className="header-name mb-4 mb-md-5">Beltstorm</h2>
            <div className="video-wrapper mb-5">
              <iframe
                src="https://www.youtube.com/embed/_HXxbN1pAxE"
                title="Beltstorm video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <p className="subtext">
              {t('Projects.beltstormSubtext')}
            </p>
            <div className="Degree d-flex align-items-center pt-4 pt-sm-5">
              <img src={penIcon} alt="Degree" />
              <a href="https://urn.fi/URN:NBN:fi:amk-2025060118863" target="_blank" rel="noopener noreferrer">{t('Projects.beltstormDegree')}</a>
            </div>
            <div className="Github d-flex align-items-center pt-4 pt-sm-5">
              <img src={githubIcon} alt="Github" />
              <a href="https://github.com/AkseliRaj/BELTSTORM-NFT-Videogame" target="_blank" rel="noopener noreferrer">{t('Projects.beltstormGithub')}</a>
            </div>
          </div>

          {/* Collect shoes */}
          <div
            ref={collectRef}
            className={`project-section fade-in-section ${collectVisible ? 'visible' : ''} mb-5`}
          >
            <h2 className="header-name mb-4 mb-md-5">Collect shoes</h2>
            <div className="video-wrapper mb-5">
              <iframe
                src="https://www.youtube.com/embed/BhV8rjAG1SA"
                title="Collect shoes video"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
            <p className="subtext">
              {t('Projects.collectShoesSubtext')}
            </p>
            <p className="subtext">
              {t('Projects.collectShoesSubtext2')}
            </p>
            <div className="Github d-flex align-items-center pt-4 pt-sm-5">
              <img src={githubIcon} alt="Github" />
              <a href="https://github.com/Miikakyl/Verkkopalvelu-projekti" target="_blank" rel="noopener noreferrer">{t('Projects.collectShoesGithub')}</a>
            </div>
          </div>

          {/* Cryptex */}
          <div
            ref={cryptexRef}
            className={`project-section fade-in-section ${cryptexVisible ? 'visible' : ''} mb-5`}
          >
            <h2 className="header-name mb-4 mb-md-5">Cryptex</h2>
            <div className="Carousel-wrapper mb-5">
              <Carousel showThumbs={false} infiniteLoop useKeyboardArrows autoPlay>
                <div><img src={cryptex1} alt="Cryptex kuva 1" /></div>
                <div><img src={cryptex2} alt="Cryptex kuva 2" /></div>
                <div><img src={cryptex3} alt="Cryptex kuva 3" /></div>
                <div><img src={cryptex4} alt="Cryptex kuva 4" /></div>
              </Carousel>
            </div>
            <p className="subtext">
              {t('Projects.cryptexSubtext')}
            </p>
            <div className="Github d-flex align-items-center pt-4 pt-sm-5">
              <img src={githubIcon} alt="Github" />
              <a href="https://github.com/AkseliRaj/Mobile-Project" target="_blank" rel="noopener noreferrer">{t('Projects.cryptexGithub')}</a>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}

export default Projects;
